<template>
  <div class="location_history">
    <div class="location_history__datepicker">

      <span class="form-group">
        <WrapDatePicker
            type="date"
            value_type="X"
            v-model="date"
            :range="true"
            :disabled_date="['- 6 months', 'now']"
            :placeholder="translate('location.date')"
            :clearable="true"
        />
      </span>

      <div class="flex-item select">
        <tree-select
            :options="params_list"
            :multiple="true"
            v-model="add_params"
            :placeholder="translate('gps_track.add_params.title')"
            :clearable="true"
        />
      </div>
    </div>
    <div class="content">
      <vue-splitter
          v-if="dev_fid"
          :margin="30"
          :horizontal="horizontal"
          style="display: flex; height:  100%; overflow: hidden "
      >
        <List
            slot="left-pane"
            :all_loc_history="all_loc_history"
            @show_info="show_info"
            @hide_info="hide_info"
        />
        <Details
            slot="right-pane"
            :selected_history="selected_history"
            @hide_info="hide_info"
        />
      </vue-splitter>
    </div>
  </div>

</template>
<script>

import VueSplitter from '@rmp135/vue-splitter'
import List from "./List/Index.vue";
import Details from "./Details/Index.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
    name: 'LocationHistory',
    components: {
      WrapDatePicker,
      VueSplitter,
      List,
      Details
    },
    props: ['dev_fid', 'profile'],

    data () {
      return {
        all_loc_history: [],
        selected_history: [],
        date: [],
        // filter: {
        //   date_start: "",
        //   date_end: ""
        // },
        add_params: []
      }
    },

    computed: {
      horizontal(){
        return document.documentElement.clientWidth <= 768;
      },
      send_filter() {
        let filter = {}
        if (this.date.length > 0 && this.date[0] !== null && this.date[1] !== null){
          filter.date_start = this.date[0]
          filter.date_end = this.date[1]
        }
        if (this.add_params.length > 0){
            this.add_params.forEach((item) => {
              filter[item] = true
            })
        }
        return filter
      },
      params_list(){
        return [
          {id: 'group_by_country', label: this.translate('location.group_by_country'), isDisabled: this.add_params.indexOf("group_by_city") > -1 },
          {id: 'group_by_city', label: this.translate('location.group_by_city'), isDisabled: this.add_params.indexOf("group_by_country") > -1  },
          {id: 'parking', label: this.translate('location.parking') },
        ]
      },
    },

    watch:{
      // date(){
      //   this.filter.date_start = this.date[0]
      //   this.filter.date_end = this.date[1]
      // },
      // add_params(){
      //   this.add_params.forEach((item) => {
      //     this.$set(this.filter, item, true)
      //     // this.filter[item] = true
      //   })
      // },
      send_filter:{
        deep: true,
        handler(){
          this.get_location_history()
        }
      }
    },
    created () {
      this.get_location_history()
    },
    methods:{
      get_location_history(){
        this.$http.v1.getDeviceLocationHistory(this.dev_fid, this.send_filter, (response) => {
          this.all_loc_history = response.data.map((item) => {
            return {...item, show: false}
          })
        })
      },
      show_info(id){
        this.$http.v1.getDeviceLocationHistoryView(id, (response) => {
          let history = this.all_loc_history.find((history) => {
            if (history.id === response.data.id) return history
          })
          history.show = true

          if (this.selected_history.length > 0){
            let check_history = this.selected_history.find((history) => {
              if (history.id === response.data.id) return history
            })
            if (!check_history){
              this.selected_history.push(response.data)
            }
          }else{
            this.selected_history.push(response.data)
          }
        })
      },
      hide_info(id){
        let history_index = this.selected_history.findIndex((history) => {
          if (history.id === id) return history
        })
        this.selected_history.splice(history_index, 1);

        let history = this.all_loc_history.find((history) => {
          if (history.id === id) return history
        })
        history.show = false
      }
    }
}

</script>
<style lang="scss" scoped>

.location_history{
  height: 100%;
  &__datepicker{
    height: 7.5%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .form-group{
      width: 20%;
      min-width: 200px;
      margin-bottom: 0px;
      margin-right: 10px;
    }
    .select{
      width: 20%;
    }
  }
  .content{
    height: 92.5%;
  }
}

</style>
